import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { RuleTag } from '../api/governance/violationRule.model';
import { RuleTagDisplayNamePipe } from 'src/app/pipes/rule-tag-display-name/rule-tag-display-name.pipe';

const allRuleTags = Object.values(RuleTag).filter((v) => isNaN(Number(v)));

export const RuleTagSelectOptions: ISelectOption[] = allRuleTags.map((ruleTag: RuleTag) => ({
  id: `${FilterTypesEnum.RuleTag}-${ruleTag}`,
  value: ruleTag,
  displayName: new RuleTagDisplayNamePipe().transform(ruleTag),
  categoryName: FilterTypesEnum.RuleTag.toString(),
  filterType: FilterTypesEnum.RuleTag,
  withoutBeautifyDisplayName: true,
}));
